import { render, staticRenderFns } from "./x-list-page-dialog.vue?vue&type=template&id=408706be"
import script from "./x-list-page-dialog.vue?vue&type=script&lang=js"
export * from "./x-list-page-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports